module.exports = __webpack_public_path__ + "static/img/beta_bg_white_03.741a5536.svg";